import React from "react";

export default function FullscreenLoader() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        backgroundColor: "rgba(0, 0, 0, 0.4)",
      }}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="spinner-border text-light" style={{ width: "3rem", height: "3rem" }}>
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
